import { q, qq } from "../../helper/q"

export const searchInit = () => {
  const buttonElement = q(".buttonSearch")
  const overlayElement = q(".searchBlackout")
  buttonElement.addEventListener("click", () => {
    showSearchBar()
  })
  overlayElement.addEventListener("click", () => {
    hideSearchBar()
  })

  window.addEventListener("resize", () => {
    setSearchWidth()
  })
}

const showSearchBar = () => {
  const searchElement = q(".search")
  const overlayElement = q(".searchBlackout")
  const headerElement = q(".header")
  const texts = qq(".menuMainText", headerElement)
  setSearchWidth()
  texts.map(text => {
    text.style.opacity = 0
  })
  searchElement.classList.add("searchVisible")
  overlayElement.classList.add("searchBlackoutVisible")
}

const hideSearchBar = () => {
  const searchElement = q(".search")
  const overlayElement = q(".searchBlackout")
  const headerElement = q(".header")
  const texts = qq(".menuMainText", headerElement)
  texts.map(text => {
    text.style.opacity = 1
  })
  searchElement.classList.remove("searchVisible")
  overlayElement.classList.remove("searchBlackoutVisible")
}

const setSearchWidth = () => {
  const buttonElement = q(".buttonSearch")
  const navMenuElement = q(".menuMainNav")
  const searchElement = q(".search")
  const offsetRight = buttonElement.getBoundingClientRect().right
  const offsetLeft = navMenuElement.getBoundingClientRect().left
  const bodyWidht = document.body.getBoundingClientRect().width
  searchElement.style.transition = "0"
  searchElement.style.width = bodyWidht - offsetLeft - (bodyWidht - offsetRight) + "px"
  setTimeout(() => {
    searchElement.style.transition = "all 0.4s"
  }, 100)
}
